import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import classnames from 'classnames';
import * as React from "react";
import CodeMirror from './components/CodeMirror';
import PreviewMarkdown from './components/PreviewMarkdown';
import ToolBar from './components/ToolBar';
import ToolBarMode from './components/ToolBarMode';
import "./index.css";

var MarkdownEditor = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(MarkdownEditor, _React$PureComponent);

  var _super = _createSuper(MarkdownEditor);

  function MarkdownEditor() {
    var _this;

    _classCallCheck(this, MarkdownEditor);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.container = void 0;
    _this.editorClientHeight = void 0;
    _this.preview = void 0;
    _this.toolbarsMode = void 0;
    _this.CodeMirror = void 0;

    _this.handleResize = function () {
      var isFullScreen = _this.toolbarsMode.state.fullscreen;

      if (isFullScreen) {
        _this.setEditorSize(isFullScreen);
      }
    };

    _this.getInstance = function (editor) {
      if (editor) {
        _this.CodeMirror = editor;
      }
    };

    _this.onChange = function (editor, data, value) {
      var _ref = _this.props,
          onChange = _ref.onChange;

      if (onChange) {
        if (_this.preview) {
          _this.preview.updateSource(editor.getValue());
        }

        onChange(editor, data, editor.getValue());
      }
    };

    _this.onBlur = function (editor, event) {
      var _ref2 = _this.props,
          onBlur = _ref2.onBlur;

      if (onBlur) {
        onBlur(editor, event);
      }
    };

    _this.onClickMode = function (type) {
      if (type === 'preview') {
        _this.previewMarkdown();

        return;
      }

      if (type === 'fullscreen') {
        _this.fullScreen();

        return;
      }
    };

    _this.onClick = function (type) {
      var selection = _this.CodeMirror.editor.getSelection();

      var pos = _this.CodeMirror.editor.getCursor();

      var value = ''; // 'header', 'strike', 'underline', 'olist', 'ulist', 'todo', 'link', 'image', 'quote', 'preview'

      if (type === 'bold') {
        value = selection ? "**".concat(selection, "**") : "****";
        pos.ch = selection ? pos.ch : pos.ch + 2;
      }

      if (type === 'italic') {
        value = selection ? "*".concat(selection, "*") : "**";
        pos.ch = selection ? pos.ch : pos.ch + 1;
      }

      if (type === 'header') {
        value = selection ? "# ".concat(selection) : '# ';
        pos.ch = selection ? pos.ch : pos.ch + 2;
      }

      if (type === 'strike') {
        value = selection ? "~~".concat(selection, "~~") : '~~~~';
        pos.ch = selection ? pos.ch : pos.ch + 2;
      }

      if (type === 'underline') {
        value = selection ? "<u>".concat(selection, "</u>") : '<u></u>';
        pos.ch = selection ? pos.ch : pos.ch + 3;
      }

      if (type === 'olist') {
        value = selection ? "- ".concat(selection) : '- ';
        pos.ch = selection ? pos.ch : pos.ch + 2;
      }

      if (type === 'ulist') {
        value = selection ? "1. ".concat(selection) : '1. ';
        pos.ch = selection ? pos.ch : pos.ch + 3;
      }

      if (type === 'todo') {
        value = selection ? "- [ ] ".concat(selection) : '- [ ] ';
        pos.ch = selection ? pos.ch : pos.ch + 6;
      }

      if (type === 'link') {
        value = '[连接说明](连接地址 "连接标题")';
      }

      if (type === 'image') {
        value = selection ? "".concat(selection, " ![](\u56FE\u7247\u5730\u5740 \"\u56FE\u7247\u63CF\u8FF0\")") : '![图片描述](图片地址 "图片描述")\n';
      }

      if (type === 'quote') {
        value = selection ? "> ".concat(selection) : '> ';
        pos.ch = selection ? pos.ch : pos.ch + 2;
      }

      _this.CodeMirror.editor.replaceSelection(value);

      _this.CodeMirror.editor.focus();

      _this.CodeMirror.editor.setCursor(pos.line, pos.ch);
    };

    return _this;
  }

  _createClass(MarkdownEditor, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          prefixCls = _this$props.prefixCls,
          className = _this$props.className,
          toolbars = _this$props.toolbars,
          toolbarsMode = _this$props.toolbarsMode,
          onChange = _this$props.onChange,
          visible = _this$props.visible,
          visibleEditor = _this$props.visibleEditor,
          previewProps = _this$props.previewProps,
          codemirrorProps = _objectWithoutProperties(_this$props, ["prefixCls", "className", "toolbars", "toolbarsMode", "onChange", "visible", "visibleEditor", "previewProps"]);

      return /*#__PURE__*/React.createElement("div", {
        ref: function ref(node) {
          return _this2.container = node;
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: classnames(prefixCls, className)
      }, /*#__PURE__*/React.createElement(ToolBarMode, {
        ref: function ref(mode) {
          return _this2.toolbarsMode = mode;
        },
        toolbarsMode: toolbarsMode,
        onClick: this.onClickMode
      }), /*#__PURE__*/React.createElement(ToolBar, {
        toolbars: toolbars,
        onClick: this.onClick
      }), /*#__PURE__*/React.createElement("div", {
        className: classnames("".concat(prefixCls, "-content"))
      }, visibleEditor && /*#__PURE__*/React.createElement(CodeMirror, _extends({
        visibleEditor: visibleEditor,
        ref: this.getInstance
      }, codemirrorProps, {
        onChange: this.onChange
      })), /*#__PURE__*/React.createElement(PreviewMarkdown, {
        visible: visible,
        ref: function ref(pmd) {
          return _this2.preview = pmd;
        },
        value: this.props.value,
        previewProps: previewProps
      }))));
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.preview && this.CodeMirror) {
        this.props.visible ? this.preview.show() : this.preview.hide();
        this.CodeMirror.editor.setSize(this.props.visible ? '50%' : '100%');

        var _this$CodeMirror$edit = this.CodeMirror.editor.getScrollInfo(),
            clientHeight = _this$CodeMirror$edit.clientHeight;

        this.editorClientHeight = clientHeight;
        window.addEventListener('resize', this.handleResize, true);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize, true);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.visible !== this.props.visible) {
        nextProps.visible ? this.preview.show() : this.preview.hide();
        this.CodeMirror.editor.setSize(nextProps.visible ? '50%' : '100%');
      }
    }
  }, {
    key: "previewMarkdown",
    value: function previewMarkdown() {
      if (this.preview) {
        this.preview.state.visible ? this.preview.hide() : this.preview.show();
        this.toolbarsMode.updateMode('preview', !this.preview.state.visible);
        this.CodeMirror.editor.setSize(this.preview.state.visible ? '100%' : '50%');
      }
    }
  }, {
    key: "fullScreen",
    value: function fullScreen() {
      var prefixCls = this.props.prefixCls;

      if (this.toolbarsMode && this.container) {
        var isFullScreen = !this.toolbarsMode.state.fullscreen;
        this.toolbarsMode.updateMode('fullscreen', isFullScreen);
        this.container.className = isFullScreen ? classnames("".concat(prefixCls, "-fullscreen")) : '';
        document.body.style.overflow = isFullScreen ? 'hidden' : 'initial';
        this.setEditorSize(isFullScreen);
      }
    }
  }, {
    key: "setEditorSize",
    value: function setEditorSize(isFullScreen) {
      var clientHeight = document.body.clientHeight;
      this.CodeMirror.editor.setSize(this.preview.state.visible ? '50%' : '100%', isFullScreen ? clientHeight - 33 : this.editorClientHeight);
    }
  }]);

  return MarkdownEditor;
}(React.PureComponent);

MarkdownEditor.displayName = 'MarkdownEditor';
MarkdownEditor.defaultProps = {
  onChange: function onChange() {
    return null;
  },
  prefixCls: 'md-editor',
  value: '',
  visibleEditor: true,
  visible: true
};
export { MarkdownEditor as default };